import { CreateBookingV3RepositoryInterface } from "@/data/persistences/repositories/contracts/CreateBookingV3RepositoryInterface";
import ApiService from "../../services/ApiService";
import { CreateBookingV3Mapper } from "@/data/persistences/mappers/CreateBookingV3Mapper";
import { CreateBookingV3Endpoint } from "../../endpoints/CreateBookingV3Endpoint";

export class CreateBookingV3ApiRepository
  implements CreateBookingV3RepositoryInterface {
  private readonly service: ApiService;
  private readonly mapper: CreateBookingV3Mapper;
  private readonly endpoints: CreateBookingV3Endpoint;

  constructor(
    service: ApiService,
    mapper: CreateBookingV3Mapper,
    endpoints: CreateBookingV3Endpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }
}
